// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"431":"bc8215e8","453":"e9bdf27b","808":"db60fb27","818":"15d73038"}[chunkId] + ".chunk.css";
};